import styled from '@emotion/styled'
import { color } from 'driverama-core/styles/variables'
import { size } from 'driverama-core/styles/spacing'

export const SNote = styled.div`
  background: ${color('night-l-800')};
  padding: ${size(3)};
`
